<template>
    <div>
        <validation-observer ref="forms" v-slot="{handleSubmit}">
            <form class="form-group" @submit.prevent="handleSubmit(submitPublicacao)">
                <div class="grid-1 form">

                    <validation-provider name="Nome" vid="nome" rules="required" v-slot="{errors}" tag="div" class="input-std form-text" >
                        <label>Nome</label>
                        <input type="text" placeholder="Nome da Publicação" v-model="form.nome" />
                        <p class="errors">{{errors[0]}}</p>
                    </validation-provider>

                    <validation-provider name="Capa" vid="capa" rules="" v-slot="{errors}" tag="div" class="input-std form-text" >
                        <label>Capa da Publicação</label>
                        <input type="file" :name="form.capa" :id="form.capa" @change="uploadCapa"  accept="image/png, image/jpeg" class="input"/>
                        <p class="errors">{{errors[0]}}</p>
                    </validation-provider>

                    <validation-provider name="Arquivo" vid="arquivo" rules="" v-slot="{errors}" tag="div" class="input-std form-text" >
                        <label>Arquivo da Publicação</label>
                        <input type="file" :name="form.arquivo" :id="form.arquivo" @change="uploadArquivo" accept=".pdf, .zip" class="input">
                        <p class="errors">{{errors[0]}}</p>
                    </validation-provider>

                </div>

                <div class="grid-1">
                    <validation-provider name="Descrição" vid="descricao" rules="required" v-slot="{errors}" tag="div" class="input-std form-text" >
                        <label>Descrição</label>
                        <textarea type="file" placeholder="Descrição da publicação" v-model="form.descricao" />
                        <p class="errors">{{errors[0]}}</p>
                    </validation-provider>
                </div>

                <div class="flex justify-end">
                    <button class="btn btn-primary">Salvar Publicação</button>
                </div>
            </form>
        </validation-observer>
    </div>
</template>

<script>
export default {
    name: 'form-publicacao',
    data() {
        return {
            form: {
                nome: '',
                descricao: '',
                capa: null,
                arquivo: null
            }
        }
    },

    methods: {
        uploadCapa(event) {
            this.form.capa = event.target.files[0]
        },

        uploadArquivo(event) {
            this.form.arquivo = event.target.files[0]
        },

        submitPublicacao() {
            let formData = new FormData()
            formData.append('nome', this.form.nome)
            formData.append('descricao', this.form.descricao)
            formData.append('capa', this.form.capa)
            formData.append('arquivo', this.form.arquivo)
            formData.append('id', null);

            this.axios.post('publicacoes', formData).then(res => {
                if (res.status === 200) {
                    this.$swal({
                        title: 'Sucesso',
                        text: 'A publicação foi criada com sucesso',
                        icon: 'success',
                    })
                    this.$router.push('/sistema/publicacoes/lista-publicacoes')
                }
            }).catch(error => {
                this.$swal({
                    title: 'Ops!',
                    text: error.response.data.message,
                    icon: 'error',
                });

            })
        },
    }
}
</script>
<style lang="scss" scoped>
    .form{
        @media(min-width: 640px) {
            @apply grid-cols-3;
        }
    }
    .input {
        overflow: hidden;
    }
</style>
